import React, {Component} from 'react';
import {Link} from 'react-router';
import {Image} from 'react-bootstrap';

class LandingPage extends Component {
  constructor(props) {
    super(props);

    let storageState = {};
    if (localStorage.nonWinner) {
      storageState.nonWinner = localStorage.nonWinner;
    }
    if (localStorage.fillColor) {
      storageState.fillColor = localStorage.fillColor;
    }
    if (localStorage.borderColor) {
      storageState.borderColor = localStorage.borderColor;
    }
    if (localStorage.buttonFontColor) {
      storageState.buttonFontColor = localStorage.buttonFontColor;
    }
    if (localStorage.fontTopPadding) {
      storageState.fontTopPadding = localStorage.fontTopPadding;
    }
    if (localStorage.fontBottomPadding) {
      storageState.fontBottomPadding = localStorage.fontBottomPadding;
    }
    if (localStorage.fontLeftPadding) {
      storageState.fontLeftPadding = localStorage.fontLeftPadding;
    }
    if (localStorage.fontRightPadding) {
      storageState.fontRightPadding = localStorage.fontRightPadding;
    }

    this.state = {
      fillColor: null,
      borderColor: null,
      buttonFontColor: null,
      fontTopPadding: null,
      fontBottomPadding: null,
      fontLeftPadding: null,
      fontRightPadding: null,
      ...storageState
    };
  }

  render() {
    //console.log('state: ', this.state, 'props: ', this.props);

    let landingPageArray;
    //parse local storage landing pages into an array
    if (localStorage.landingPages === '' && localStorage.landingPages !== 'undefined') {
      landingPageArray = [];
    } else {
      landingPageArray = localStorage.landingPages.split(',');
    }

    const fillColor =
      this.state.fillColor === 'null' ? null : this.state.fillColor;
    const borderColor = this.state.borderColor;
    const buttonFontColor = this.state.buttonFontColor;

    const buttonTopPadding = 0 + Number(this.state.fontTopPadding);
    const buttonBottomPadding = 0 + Number(this.state.fontBottomPadding);
    const buttonLeftPadding = 60 + Number(this.state.fontLeftPadding);
    const buttonRightPadding = 60 + Number(this.state.fontRightPadding);

    const index = parseInt(this.props.params.index, 10) || 0;
    const nextIndex = index + 1;
    const landingPageUrl = landingPageArray[index];

    let next;

    if (landingPageArray.length - 1 === index) {
      if (localStorage.redemptionPage === 'true') {
        next = '/redeem';
      } else {
        next = '/thanks';
      }
    } else {
      next = '/landingpage/' + nextIndex.toString();
    }

    let continueButton = (
      <Link
        to={{pathname: next, state: {index: nextIndex}}}
        onClick={() => {}}
        className="genericBtn"
        style={{
          color: buttonFontColor || 'white',
          background: fillColor || 'grey',
          borderColor: borderColor || 'red',
          padding: buttonTopPadding + 'px ' + buttonRightPadding + 'px ' + buttonBottomPadding + 'px ' + buttonLeftPadding + 'px'
        }}>
        Continue
      </Link>
    );

    return (
      <div className="genericAppInner">
        <div id="intro" className="page">
          <div className="verticalWrap contentWrap">
            <div className="genericInnerWrap">
              <div className="landingPageParent">
                <Image
                  responsive
                  rounded
                  className="landingPage"
                  alt="loading..."
                  src={landingPageUrl}
                />
              </div>
              <div className="continue">{continueButton}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/LandingPage.js